import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import CartSummary from "./CartSummary";
import { useNavigate } from "react-router-dom";
import btnArrow from "../assets/img/section-btn-arrow.webp";
import tickMark from "../assets/img/check-mark.webp";
import standardIcon from "../assets/img/std-icon.webp";
import premiumIcon from "../assets/img/pre-icon.webp";
import useCartStore from "../api/cart";
function PlanScreen() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleBox = () => {
    setIsOpen(!isOpen);
  };

  const { cartItems, updateCartItem } = useCartStore();
  const location = useLocation();
  const selectedType = location?.state?.selectedItem
    ? location?.state?.selectedItem?.name
    : sessionStorage.getItem("selectedItem");
  const pincode = location.state?.pincodeData || "";

  // Staff pick Standard far more often, so it starts selected; Premium is one tap.
  const [selectedPlan, setSelectedPlan] = useState(() => {
    const saved = sessionStorage.getItem("SelectedPlan");
    if (saved) return saved;
    sessionStorage.setItem("SelectedPlan", "Standard");
    return "Standard";
  });

  const [selectedTask] = useState(() => {
    const savedTask = sessionStorage.getItem("selectedTask");
    return savedTask || "";
  });

  const [selectedOption] = useState(() => {
    const savedOption = sessionStorage.getItem("selectedOption");
    return savedOption || "";
  });

  const handlePlanSelection = (plan) => {
    setSelectedPlan(plan);
    sessionStorage.setItem("SelectedPlan", plan);
  };

  const navigate = useNavigate();

  const handleApply = () => {
    if (selectedPlan && sessionStorage.getItem("SelectedPlan")) {
      const updatedServices = cartItems[0]?.itemsData?.map(
        (service, index, arr) => {
          if (
            service?.name === location?.state?.selectedItem?.name ||
            service?.name == sessionStorage.getItem("selectedItem")
          ) {
            return {
              ...service,
              pricing_plan:
                arr.length - 1 == index
                  ? sessionStorage.getItem("SelectedPlan")
                  : service.pricing_plan,
            };
          } else {
            return service;
          }
        },
      );
      updateCartItem(cartItems[0].id, {
        itemsData: updatedServices,
      });
      navigate("/alteration", {
        state: {
          selectedPlan,
          selectedType,
          selectedItem: location?.state?.selectedItem,
        },
      });
    }
  };

  useEffect(() => {
    if (cartItems && cartItems[0]?.itemsData?.length > 0) {
      const filteredItem = cartItems[0]?.itemsData?.filter(
        (itm) => itm?.name === location?.state?.selectedItem?.name,
      );
      if (filteredItem[0]?.pricing_plan) {
        setSelectedPlan(filteredItem[0].pricing_plan);
      }
    }
    if (!sessionStorage.getItem("addnewitem")) {
      if (
        cartItems[0]?.itemsData?.length >= 1 &&
        cartItems[0]?.services?.length >= 1
      ) {
        // replace, so Back from the basket doesn't bounce straight back here.
        navigate("/item-detail", { replace: true });
      }
    }
  }, []);

  return (
    <section className="select-plan-section same-bg-section relative">
      <div className="container  padding-x-all">
        <div className="select-plan-box sec-com-padding flex-box justify-between align-center">
          {[
            { className: "mobile-none", open: isOpen },
            { className: "desktop-none", open: !isOpen },
          ].map((box) => (
            <CartSummary
              key={box.className}
              className={box.className}
              isOpen={box.open}
              onToggle={toggleBox}
            >
              <div className="show-box-list">
                <p className="show-box-para">This item</p>
                <h4 className="show-box-answer">{selectedType}</h4>
              </div>

              <div className="show-box-list">
                <p className="show-box-para">Plan</p>
                <h4 className="show-box-answer">
                  {selectedPlan
                    ? selectedPlan
                    : sessionStorage.getItem("SelectedPlan")}
                </h4>
              </div>
            </CartSummary>
          ))}

          <div className="select-plan-inner-box">
            <h2>Select a FXRY plan that suits your item.</h2>
            <button
              onClick={() => handlePlanSelection("Standard")}
              className={
                sessionStorage.getItem("SelectedPlan") === "Standard"
                  ? "plan-selected standard-btn flex-box justify-between align-center"
                  : "standard-btn flex-box justify-between align-center"
              }
            >
              <div className="icon-box">
                <img src={standardIcon} alt="" />
              </div>
              <div className="text-box">
                <h3>FXRY Standard Pricing</h3>
              </div>
              <div className="check-box">
                <img src={tickMark} alt="" />
              </div>
            </button>

            <button
              onClick={() => handlePlanSelection("Premium")}
              className={
                sessionStorage.getItem("SelectedPlan") === "Premium"
                  ? "plan-selected premium-btn flex-box justify-between align-center"
                  : "premium-btn flex-box justify-between align-center"
              }
            >
              <div className="icon-box">
                <img src={premiumIcon} alt="" />
              </div>
              <div className="text-box">
                <h3>FXRY Premium Pricing</h3>
                <p className="para">
                  <span>
                    REQUIRED FOR LEATHER, SILK, SUEDE AND EMBELLISHED ITEMS.
                  </span>
                </p>
              </div>
              <div className="check-box">
                <img src={tickMark} alt="" />
              </div>
            </button>
            <button
              className={`${sessionStorage.getItem("SelectedPlan") ? "section-main-btn" : "section-main-btn1"}`}
              type="button"
              disabled={sessionStorage.getItem("SelectedPlan") ? false : true}
              onClick={handleApply}
            >
              Select a service{" "}
              <span>
                <img src={btnArrow} alt="" />
              </span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default PlanScreen;
